import { ProfileTitle } from './ProfileComponents.tsx'
import { FormattedMessage } from 'react-intl'

export const ProfileAbout = () => {
  return (
    <div>
      <ProfileTitle title={<FormattedMessage id="user.aboutUs" />} />
    </div>
  )
}
